export default __webpack_public_path__ + "static/media/group.6a9129fd.png";